document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-nav-toggle]');
  if (!t) return;
  var nav = document.querySelector('[data-nav]');
  if (!nav) return;
  var open = nav.classList.toggle('is-open');
  t.setAttribute('aria-expanded', open ? 'true' : 'false');
});

/* Gravur: Live-Vorschau + Zeichenzähler */
document.addEventListener('input', function (e) {
  var input = e.target.closest('[data-engrave-input]');
  if (!input) return;
  var box = input.closest('[data-engrave]');
  if (!box) return;
  var preview = box.querySelector('[data-engrave-preview]');
  var count = box.querySelector('[data-engrave-count]');
  if (preview) preview.textContent = input.value || preview.getAttribute('data-empty') || '';
  if (count) count.textContent = input.value.length + ' / ' + (input.getAttribute('maxlength') || '');
});
document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-engrave-font]');
  if (!sel) return;
  var box = sel.closest('[data-engrave]');
  var preview = box && box.querySelector('[data-engrave-preview]');
  if (preview) preview.style.fontFamily = sel.value === 'Blockschrift' ? "'Archivo', sans-serif" : "'Dancing Script', cursive";
});
